export function isWindows() {
  return navigator.platform.toUpperCase().indexOf('WIN') >= 0;
}